<template>
  <div class="swiper">
    <swiper refs="mySwiper"
            class="swiper"
            v-if="bannerlists.length > 0"
            :options="enterpriseOption">
      <swiper-slide class="swiper-slide"
                    v-for="item in bannerlists"
                    :key="item.sortseq">
        <img :src="item.fileUrl"
             class="absolute-leftTop-center slide-img" />
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"
         slot="pagination"></div>
  </div>
</template>
<script>
import "../assets/css/swiper-3.4.2.min.css";
import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
import api from '../api/api'
export default {
  data () {
    return {
      enterpriseOption: {
        loop: true, //衔接
        autoplay: {
          delay: 3000, //1秒切换一次
          disableOnInteraction: true,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        lazyLoading: false,
        preloadImages: false,
        //设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      list: [{
        id: 0,
        // bgColor: '#7078E3',
        // url: require('../assets/images/banner1.png')
      },
      {
        id: 1,
        // bgColor: '#ED4870',
        // url: require('../assets/images/banner2.png')
      }
      ],
      bannerlists: [],
    };

  },
  components: {
    swiper,
    swiperSlide
  },
  created () {
    this.comforist()
  },
  methods: {
    //天使列表
    comforist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 5,

      }
      api.comforlist(parm).then((res) => {
        this.bannerlists = []
        this.bannerlists = res.data.list

      })

    },
  }
}
</script>

<style scoped>
.swiper {
  position: relative !important;
}
.swiper-slide {
  position: relative;
  width: 300px;
  height: 450px;
}
.slide-img {
  width: 100%;
  height: 100%;
}
.swiper-button-prev {
  width: 120px !important;
  height: 120px !important;
  background-image: url("../assets/images/icon_left.png") !important;
  /* background-repeat: no-repeat, no-repeat, repeat-y;
  background-position: center top, center bottom, center top; */
  background-size: 80px !important;
}
.swiper-button-next {
  width: 120px !important;
  height: 120px !important;
  background-image: url("../assets/images/icon_right.png") !important;
  /* background-repeat: no-repeat, no-repeat, repeat-y;
  background-position: center top, center bottom, center top; */
  background-size: 80px !important;
}
.swiper-button-next:hover {
  background-image: url("../assets/images/icon_right_h.png") !important;
}
.swiper-button-prev:hover {
  background-image: url("../assets/images/icon_left_h.png") !important;
}
.swiper-pagination {
  position: absolute;
  bottom: 20px;
  width: fit-content !important;
  width: 100% !important;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.swiper-pagination-bullet {
  width: 10px !important;
  height: 10px !important;
}
.swiper-pagination-bullet-active {
  background: #ff0000 !important;
}
.swiper-container-horizontal
  .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 20px !important;
}
</style>
